import {FC, ReactNode} from 'react';
import {IPersonaProps, Label} from '@fluentui/react';
import styles from './confirmationModal.module.scss';

import {ModalWithHeader} from '../../common/ModalWithHeader';
import {TheButton} from '../../common/TheButton';
import {DocumentSystem} from '../../../models/DocumentSystem';
import {AcknowledgementsProcess} from '../../../models/AcknowledgementsProcess';

interface IConfirmationModalProps {
  isVisible: boolean;
  comment: string;
  people: IPersonaProps[] | undefined;
  groups: IPersonaProps[] | undefined;
  documents: DocumentSystem[] | [];
  processes: AcknowledgementsProcess[] | [];
  deadline: Date | undefined | null;
  onConfirm: () => void;
  onClose: () => void;
  children?: ReactNode;
}
export const ConfirmationModal: FC<IConfirmationModalProps> = ({
  isVisible,
  people,
  groups,
  documents,
  processes,
  deadline,
  comment,
  onClose,
  onConfirm,
}) => (
  <>
      <ModalWithHeader
        header="Confirm Acknowledgement Form"
        isVisible={isVisible}
        dismiss={onClose}>
        {people && people.length ? (
          <>
            <Label>Recipients - Individual Email Address</Label>
            <div className={styles.container}>
              <ul>
                {people.map((item, index) => (
                  <li key={index}>{item.text}</li>
                ))}
              </ul>
            </div>
          </>
        ) : undefined}
        {groups && groups.length ? (
          <>
            <Label>Recipients - Group Email Addresses</Label>
            <div className={styles.container}>
              <ul>
                {groups.map((item, index) => (
                  <li key={index}>{item.text}</li>
                ))}
              </ul>
            </div>
          </>
        ) : undefined}
        {deadline ? (
          <>
            <Label>Deadline</Label>
            <div className={styles.container}>{deadline.toDateString()}</div>
          </>
        ) : undefined}
        {comment ? (
          <>
            <Label>Background / Reason</Label>
            <div
              className={styles.container}
              dangerouslySetInnerHTML={{
                __html: comment
              }}>
            </div>
          </>
        ) : undefined}
        {documents && documents.length ? (
          <>
            <Label>Choosen documents</Label>
            <div className={styles.container}>
              <ul>
                {documents.map((item, index) => (
                  <li key={index}>{item.title}</li>
                ))}
              </ul>
            </div>
          </>
        ) : undefined}

        {processes && processes.length ? (
          <>
            <Label>Choosen processes</Label>
            <div className={styles.container}>
              <ul>
                {processes.map((item, index) => (
                  <li key={index}>{item.title}</li>
                ))}
              </ul>
            </div>
          </>
        ) : undefined}

        <div className={styles.buttons}>
          <TheButton primary onClick={onClose}>
            Cancel
          </TheButton>

          <TheButton primary onClick={onConfirm}>
            Send
          </TheButton>
        </div>
      </ModalWithHeader>
  </>
);
